/** `router.push`/`router.replace` reject when a navigation is superseded before it settles (Next's
 * route-change cancellation, e.g. two rapid clicks). That is expected behavior, not a failure to
 * surface — pass this to `.catch()` instead of leaving a bare swallow at every call site. */
export const ignoreCancelledNavigation = () => undefined;
